import React, { useRef } from 'react'
import {
  Button, Row, Col,
} from 'antd'

import {
  LeftOutlined, RightOutlined,
} from '@ant-design/icons'

import { useScroll } from 'ahooks'
import { useIsSmallDevice } from '../../hookreducer/hooks'

import __ from '../../languages/parser'

import RecapMenu from './RecapMenu'

import {
  ONDE_URL, ECHO_URL, FLUX_URL, LUMI_URL,
  ZENITH_PPOT_URL, ZENITH_PVER_URL, HALO_PPOT_URL, HALO_PVER_URL,
  TABLES_GIGOGNES_URL,
} from '../../static/url'


const ImageInsideButtonSmall = ({ src, alt, text }) => (
  <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
    <div style={{ margin: '0 4px' }}>
      <img src={src} style={{ height: '20px' }} alt={alt} />
    </div>
    <div style={{ margin: '0 14px' }}>
      {text}
    </div>
  </div>
)

const ImageInsideButton = ({
  src, alt, text,
}) => (
  <Row style={{ width: '100%' }}>
    <Col span={8} style={{ textAlign: 'center' }}>
      <img src={src} style={{ height: '24px' }} alt={alt} />
    </Col>
    <Col span={16} style={{ textAlign: 'left' }}>
      {text}
    </Col>
  </Row>
)

const AccessoriesMenuSmall = ({
  addElement,
}) => {
  const ref = useRef(null)
  const { left } = useScroll(ref)
  const maxScroll = ref.current ? ref.current.scrollWidth - ref.current.clientWidth : null

  const scrollLimit = left === 0 ? 'left' : left >= maxScroll - 1 ? 'right' : 'both'
  const setScroll = (direction) => {
    const stepScroll = direction === 'right' ? 100 : -100
    ref.current.scrollLeft += stepScroll
  }

  const accessoriesStyle = {
    marginBottom: '0.4em',
  }
  const SIZE = 'default'
  const MARGIN_BUTTON = '6px'

  const blocStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '10px',
    maxHeight: '84px',
    borderRadius: '12px',
    fontSize: '0.8em',
  }

  const blocStyleButtons = {
    marginTop: '4px',
    display: 'flex',
    flexDirection: 'row',
  }

  return (
    <Row>

      <Col span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
        {scrollLimit === 'left' ? null
          : (
            <Button
              block
              type="text"
              size="small"
              style={{
                padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
              }}
              onClick={() => setScroll('left')}
            >
              <LeftOutlined style={{ position: 'relative', top: '26px' }} />
            </Button>
          )}

      </Col>

      <Col offset={1} span={20}>
        <div
          style={{
            overflowX: 'scroll',
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            paddingBottom: '10px',
            height: '74px',
          }}
          ref={ref}
        >

          <div style={blocStyle}>
            <div>
              {__('Lampes BOM')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('zenith_1_ppot')}>
                <ImageInsideButtonSmall src={ZENITH_PPOT_URL} alt={__('Lampe Zenith posée')} text={__('Zenith posée')} />
              </Button>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('zenith_1_pver')}>
                <ImageInsideButtonSmall src={ZENITH_PVER_URL} alt={__('Lampe Zenith suspendue')} text={__('Zenith suspendue')} />
              </Button>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('halo_2_ppot')}>
                <ImageInsideButtonSmall src={HALO_PPOT_URL} alt={__('Lampe Halo posée')} text={__('Halo posée')} />
              </Button>
              <Button size={SIZE} style={accessoriesStyle} onClick={() => addElement('halo_2_pver')}>
                <ImageInsideButtonSmall src={HALO_PVER_URL} alt={__('Lampe Halo suspendue')} text={__('Halo suspendue')} />
              </Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Vases BOM')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('lumi_1')}>
                <ImageInsideButtonSmall src={LUMI_URL} alt={__('Vase Lumi')} text="Lumi" />
              </Button>
              <Button size={SIZE} style={accessoriesStyle} onClick={() => addElement('flux_2')}>
                <ImageInsideButtonSmall src={FLUX_URL} alt={__('Vase Flux')} text="Flux" />
              </Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Miroirs BOM')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('echo_1')}>
                <ImageInsideButtonSmall src={ECHO_URL} alt={__('Miroir Echo')} text="Echo" />
              </Button>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('onde_2')}>
                <ImageInsideButtonSmall src={ONDE_URL} alt={__('Miroir Onde')} text="Onde" />
              </Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Autres')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('tables_gigognes')}>
                <ImageInsideButtonSmall src={TABLES_GIGOGNES_URL} alt={__('Tables gigognes')} text={__('Tables gigognes')} />
              </Button>
            </div>
          </div>

        </div>


      </Col>
      <Col offset={1} span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
        {scrollLimit === 'right' ? null
          : (
            <Button
              block
              type="text"
              size="small"
              style={{
                padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
              }}
              onClick={() => setScroll('right')}
            >
              <RightOutlined style={{ position: 'relative', top: '26px' }} />
            </Button>
          )}
      </Col>
    </Row>

  )
}

const AccessoriesMenu = ({
  addElement, setTag, isTagged, setQuotes, isQuotes, metalColor,
  woodColor, setMetalColor, setWoodColor,
}) => {
  const SIZE = 'default'
  const accessoriesStyle = {
    marginBottom: '0.4em',
    padding: 0,
  }
  const accessoriesStyleMarginBottom = {
    ...accessoriesStyle,
    marginBottom: '1em',
  }

  return (
    <>

      <div className="maker-subtitle">
        {__('Lampes BOM')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('zenith_1_ppot')}>
        <ImageInsideButton src={ZENITH_PPOT_URL} alt={__('Lampe Zenith posée')} text={__('Lampe Zenith posée')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyleMarginBottom} block onClick={() => addElement('zenith_1_pver')}>
        <ImageInsideButton src={ZENITH_PVER_URL} alt={__('Lampe Zenith suspendue')} text={__('Lampe Zenith suspendue')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('halo_2_ppot')}>
        <ImageInsideButton src={HALO_PPOT_URL} alt={__('Lampe Halo posée')} text={__('Lampe Halo posée')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('halo_2_pver')}>
        <ImageInsideButton src={HALO_PVER_URL} alt={__('Lampe Halo suspendue')} text={__('Lampe Halo suspendue')} />
      </Button>

      <div className="maker-subtitle">
        {__('Vases BOM')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('lumi_1')}>
        <ImageInsideButton src={LUMI_URL} alt={__('Vase Lumi')} text={__('Vase Lumi')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('flux_2')}>
        <ImageInsideButton src={FLUX_URL} alt={__('Vase Flux')} text={__('Vase Flux')} />
      </Button>

      <div className="maker-subtitle">
        {__('Miroirs BOM')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('echo_1')}>
        <ImageInsideButton src={ECHO_URL} alt={__('Miroir Echo')} text={__('Miroir Echo')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('onde_2')}>
        <ImageInsideButton src={ONDE_URL} alt={__('Miroir Onde')} text={__('Miroir Onde')} />
      </Button>

      <div className="maker-subtitle">
        {__('Tables gigognes')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('tables_gigognes')}>
        <ImageInsideButton src={TABLES_GIGOGNES_URL} alt={__('Tables gigognes')} text={__('Tables gigognes')} />
      </Button>


      <RecapMenu
        setTag={setTag}
        isTagged={isTagged}
        setQuotes={setQuotes}
        isQuotes={isQuotes}
        metalColor={metalColor}
        woodColor={woodColor}
        setWoodColor={setWoodColor}
        setMetalColor={setMetalColor}
      />
    </>
  )
}

const AccessoriesMenuContainer = (props) => {
  const isSmall = useIsSmallDevice()
  return isSmall ? <AccessoriesMenuSmall {...props} /> : <AccessoriesMenu {...props} />
}
export default AccessoriesMenuContainer
